export const processingData = [
    {
        title: '',
        type: '',
        text: (
            <>
                <a href="/#">Wuxal R Max</a> / <a href="/#">Wuxal MacroMix</a> / <a href="/#">Wuxal Universal Active</a>{' '}
                treatments provide plants with essential macro and microelements for rapid growth and development,
                increase tillering productivity.
            </>
        ),
    },
    {
        title: '',
        type: '',
        text: (
            <>
                <a href="/#">Wuxal Grain</a> / <a href="/#">Wuxal Grain Active</a> / <a href="/#">Wuxal Microplant</a> /
                improve vegetative growth and development, prevent chlorosis, and improve product quality.
            </>
        ),
    },
    {
        title: '',
        type: '',
        text: (
            <>
                <a href="/#">Wuxal BIO Ascophol</a> improves resistance to biotic and abiotic stresses. Stimulates plant
                growth and development.
            </>
        ),
    },
    {
        title: '',
        type: '',
        text: (
            <>
                <a href="/#">Wuxal BIO Aminoplantl</a> is used to relieve herbicide stress and increase plant resistance
                to low and high temperatures and drought.
            </>
        ),
    },
    {
        title: '',
        type: '',
        text: (
            <>
                <a href="/#">Wuxal Sulphur</a> optimizes nitrogen nutrition, has a positive effect on protein synthesis,
                and increases plant resistance to diseases.
            </>
        ),
    },
];
